export default [
  {text:'10 rows', value:10},
  {text:'20 rows', value:20},
  {text:'50 rows', value:50},
  {text:'100 rows', value:100}]
